import { ChevronLeftIcon } from "lucide-react";

export const Header = (
  { backVisible = false, onBack, subtitle }: {
    backVisible?: boolean;
    onBack?: () => void;
    subtitle?: string | null;
  }) => {
  return (
    <div className="flex h-[80px] sticky top-0 px-4 justify-between items-center bg-tertiary border-b border-border w-full z-50">
      {backVisible ? (
        <button onClick={onBack} className="flex items-center gap-1 w-10">
          <ChevronLeftIcon className="min-w-5 h-5 text-accent-light" />
          <span className="text-accent-light text-sm font-medium">Back</span>
        </button>
      ) : <div className="w-10" />}
      <div className="flex flex-col items-center gap-1">
        <div className="text-text-primary text-sm font-medium">
          Trigger
        </div>
        <div className="text-text-secondary text-xs font-medium">
          {subtitle}
        </div>
      </div>
      <img src="/logo.svg" alt="Logo" className="w-10 h-10" />
    </div>
  );
};